import { InvoiceModel } from "../invoicing/invoice.model";
import { CashReceiptModel } from "./cash-receipt.model";

export class InvoiceCashReceiptModel {
  invoiceCashReceiptId: number = 0;
  cashReceiptId: number = 0;
  cashReceipt: CashReceiptModel = new CashReceiptModel();
  invoiceId: number = 0;
  invoice: InvoiceModel = new InvoiceModel();
  reteFuenteValue: number = 0;
  reteIvaValue: number = 0;
  reteIcaValue: number = 0;
  otherTaxes: number = 0;
  discountValue: number = 0;
  paidValue: number = 0;
  createDate: string = "";
  userNameCreate: string = "";
  updateDate: string | null = null;
  userNameUpdate: string | null = null;

  //Solo front: Se usa para captura detalle
  consecutiveInvoice: number = 0;
  residueValueInvoice: number = 0;
}